import { useEffect, useState } from 'react';
import { notesApi } from '@/lib/notesApi';

// Label sizes for the Tag Workspace: the user's own + the company's published ones.
const EMPTY = { mine: [], company: [], canPublish: false };
let cache = null;
let pending = null;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn(cache));

async function load() {
  if (cache) return cache;
  if (!pending) {
    pending = notesApi.get('/notes/tag-workspace/prefs')
      .then(({ data }) => ({ mine: data.label_presets || [], company: data.company_presets || [], canPublish: !!data.can_publish }))
      .catch(() => EMPTY)
      .then((v) => { cache = v; pending = null; emit(); return v; });
  }
  return pending;
}

// Call after the super admin switches company so company sizes reload.
export function reloadLabelPresets() {
  cache = null;
  load();
}

export async function saveLabelPresets(next) {
  const { data } = await notesApi.put('/notes/tag-workspace/prefs', { label_presets: next });
  cache = { ...(cache || EMPTY), mine: data.label_presets || [] };
  emit();
}

export async function saveCompanyPresets(next) {
  const { data } = await notesApi.put('/notes/tag-workspace/company-presets', { presets: next });
  cache = { ...(cache || EMPTY), company: data.company_presets || [] };
  emit();
}

export function useLabelPresets() {
  const [state, setState] = useState(cache || EMPTY);
  useEffect(() => {
    listeners.add(setState);
    load();
    return () => listeners.delete(setState);
  }, []);
  return state;
}
